import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import ExplevelDashboard from '../ExplevelDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import ExplevelPageImpl from './ExplevelPageImpl';

export default function ExplevelPage() {
    const dispatch = useDispatch();
    const { explevelList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < ExplevelPageImpl />
    )

}